// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-wrapper {
  display: flex;
  align-items: center;
  position: fixed;
  top: 10px;
  left: 15px;
  z-index: 9999;
}

.timer-container {
  background-color: #fff;
  padding: 10px;
  margin-right: 10px;
}

.timer {
  font-size: 2rem;
  font-weight: bold;
}

.negative .timer {
  color: red;
}

.pause-button {
  padding: 10px;
  border: none;
  background-color: #009374;
  color: #fff;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;
}

.pause-button:hover {
  background-color: #007d66;
}

.card-info {
  text-align: center;
}

/* Responsive */
/* Responsive */
@media (max-width: 600px) {
  .timer {
    font-size: 1.4rem;
  }
  .pause-button {
    font-size: 1.4rem;
    border-radius: 20px;
  }
}

@media (min-width: 600px) {
  .timer {
    font-size: 1.6rem;
  }
  .pause-button {
    font-size: 1.6rem;
    border-radius: 25px;
  }
}

@media (min-width: 768px) {
  .timer {
    font-size: 2.0rem;
  }
  .pause-button {
    font-size: 2.0rem;
    border-radius: 20px;
  }
}

@media (min-width: 992px) {
  .timer {
    font-size: 1.2rem;
  }
  .pause-button {
    font-size: 1.2rem;
    border-radius: 15px;
  }
}

@media (min-width: 1200px) {
  .timer {
    font-size: 1.4rem;
  }
  .pause-button {
    font-size: 1.4rem;
    border-radius: 15px;
  }
}



/* .question-modal {
  padding: 20px;
}

.question-modal p {
  margin-bottom: 10px;
}

.question-modal div {
  margin-bottom: 10px;
}

.question-modal input[type="radio"] {
  margin-right: 10px;
}


.question-modal input[type="radio"] + label {
  cursor: pointer;
}

.question-modal input[type="radio"] + label:hover {
  color: green;
} */

`, "",{"version":3,"sources":["webpack://./src/Components/Sub-Components/Timer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;GAuBG","sourcesContent":[".timer-wrapper {\n  display: flex;\n  align-items: center;\n  position: fixed;\n  top: 10px;\n  left: 15px;\n  z-index: 9999;\n}\n\n.timer-container {\n  background-color: #fff;\n  padding: 10px;\n  margin-right: 10px;\n}\n\n.timer {\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.negative .timer {\n  color: red;\n}\n\n.pause-button {\n  padding: 10px;\n  border: none;\n  background-color: #009374;\n  color: #fff;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;\n}\n\n.pause-button:hover {\n  background-color: #007d66;\n}\n\n.card-info {\n  text-align: center;\n}\n\n/* Responsive */\n/* Responsive */\n@media (max-width: 600px) {\n  .timer {\n    font-size: 1.4rem;\n  }\n  .pause-button {\n    font-size: 1.4rem;\n    border-radius: 20px;\n  }\n}\n\n@media (min-width: 600px) {\n  .timer {\n    font-size: 1.6rem;\n  }\n  .pause-button {\n    font-size: 1.6rem;\n    border-radius: 25px;\n  }\n}\n\n@media (min-width: 768px) {\n  .timer {\n    font-size: 2.0rem;\n  }\n  .pause-button {\n    font-size: 2.0rem;\n    border-radius: 20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .timer {\n    font-size: 1.2rem;\n  }\n  .pause-button {\n    font-size: 1.2rem;\n    border-radius: 15px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .timer {\n    font-size: 1.4rem;\n  }\n  .pause-button {\n    font-size: 1.4rem;\n    border-radius: 15px;\n  }\n}\n\n\n\n/* .question-modal {\n  padding: 20px;\n}\n\n.question-modal p {\n  margin-bottom: 10px;\n}\n\n.question-modal div {\n  margin-bottom: 10px;\n}\n\n.question-modal input[type=\"radio\"] {\n  margin-right: 10px;\n}\n\n\n.question-modal input[type=\"radio\"] + label {\n  cursor: pointer;\n}\n\n.question-modal input[type=\"radio\"] + label:hover {\n  color: green;\n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
